import '../css/main.scss'
import Hero from './elements/hero';
import Header from './includes/header';
import Dependencies from './utilities/dependencies';
import DependencyManager from './utilities/dependency-manager';
import MosaicSlider from './mosaic/mosaic-slider';
import Revinate from './includes/revinate';
import MosaicRestaurant from './mosaic/mosaic-restaurant';
import InfoBox from './includes/info-box';
import Gallery from './includes/gallery';
import MosaicOffer from './mosaic/mosaic-offer';
import BookingSearchForm from './includes/booking-search-form';
import Room from './elements/room';
import ContentRow from './elements/content-row';
import Places from './elements/places';
import Offers from './elements/offers';
import Blog from './components/blog';
import MosaicItemText from './mosaic/mosaic-item-text';
import MosaicContentDropdown from './mosaic/mosaic-content-dropdown';
import HeaderMobile from './mobile/header';
import PlacesMobile from './mobile/elements/places';
import Faqs from "./elements/faqs";
import TelLink from "./utilities/tel-link";
import MosaicHotel from "./mosaic/mosaic-hotel";
import InfoRow from "./elements/info-row";



document.querySelectorAll('header.mobile-view').forEach(e => new HeaderMobile(e));


const baseDependencies = [
	Dependencies.libraries.lazysizes,
	Dependencies.libraries.bootstrap,
];

const modules = [
	Hero,
	InfoBox,
	Gallery,
	BookingSearchForm,
	Header,
	MosaicContentDropdown,
	MosaicRestaurant,
	MosaicOffer,
	MosaicSlider,
	MosaicItemText,
	Revinate,
	Room,
	ContentRow,
	Places,
	Offers,
	Blog,
	PlacesMobile,
	Faqs,
	TelLink,
	MosaicHotel,
	InfoRow
];

DependencyManager.load(baseDependencies, modules);
